var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOkay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6927 25.113L27.8633 14.4331C28.0522 13.5097 27.8147 12.5594 27.2208 11.8304C26.6213 11.1016 25.7413 10.6804 24.7963 10.6804H19.5695L20.428 6.4633C20.6224 5.48589 20.374 4.48165 19.7476 3.71488C19.1159 2.94268 18.1818 2.5 17.1829 2.5H16.3136C15.6385 2.5 15.0878 3.0453 15.0878 3.71488C15.0878 5.16725 14.5425 8.9685 9.56413 12.786L9.35352 12.948V25.4856L10.617 26.4414C11.346 26.9921 12.2531 27.2944 13.1656 27.2944H23.0195C24.3103 27.2947 25.4335 26.3767 25.6927 25.1133L25.6927 25.113Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.44256 27.5001H2.83682V27.4998C2.37242 27.4998 2 27.1272 2 26.6685V12.7216C2 12.2574 2.37243 11.8848 2.83682 11.8848H7.44256C7.90153 11.8848 8.27418 12.2572 8.27418 12.7216V26.6685C8.27418 27.1274 7.90153 27.5001 7.44256 27.5001ZM6.71357 23.9849C6.71357 23.2615 6.13055 22.6783 5.41238 22.6783C4.689 22.6783 4.1003 23.2615 4.1003 23.9849C4.1003 24.7137 4.68877 25.297 5.41238 25.297C6.13055 25.297 6.71357 24.7139 6.71357 23.9849ZM5.44943 16.2543C6.20426 16.2543 6.81617 15.6424 6.81617 14.8875C6.81617 14.1327 6.20426 13.5208 5.44943 13.5208C4.6946 13.5208 4.08269 14.1327 4.08269 14.8875C4.08269 15.6424 4.6946 16.2543 5.44943 16.2543Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkay);
export default __webpack_public_path__ + "static/media/Okay.ca17afa89e0e04e3d3d3a7b47d789151.svg";
export { ForwardRef as ReactComponent };